var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{color:#2c3e50;font-family:Trebuchet MS,Lucida Sans Unicode,Lucida Grande,Lucida Sans,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.centre{background-color:#141414;margin:auto;padding-left:4px;padding-right:4px;max-width:145vh;background-size:contain;text-align:center;-webkit-box-shadow:0 0 620px 115px rgba(0,0,0,.85);-moz-box-shadow:0 0 620px 115px rgba(0,0,0,.85);box-shadow:0 0 620px 115px rgba(0,0,0,.85)}body,html{background-image:url(" + escape(require("./assets/hex.png")) + ");background-repeat:repeat;background-color:#191919}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77d99c2e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 84
// module chunks = 0